var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"chass":"app-container"}},[_c('div',{staticClass:"chart-container"},[_vm._v("\r\n      功能完善中\r\n    ")])])}]

export { render, staticRenderFns }